/**
 * APPLE PAY INSIDE AN APP, FOR ONE DEVICE, FOR A WHILE (2026-11-02). The owner: "is the apple pay enabled for flows from
 * the in-app in facebook/instagram? … can you enable it for a while … and try the flow". Every shopper keeps the rule of
 * 2026-09-29 (no wallet inside Instagram's or Facebook's browser). A link opened once inside the app — `?walletTest=on`
 * on any shop page — marks THIS device's copy of that app's browser for three days; `?walletTest=off` ends it sooner.
 * The mark is the end time, kept in that browser's localStorage; nothing is sent anywhere.
 */
const KEY = 'stylon:walletTest';
export const WALLET_TEST_DAYS = 3;

const local = () => {
  try { return typeof window !== 'undefined' ? window.localStorage : null; } catch (e) { return null; }
};

export function walletTestOn(storage = local(), now = Date.now()) {
  try {
    const until = Number(storage ? storage.getItem(KEY) : NaN);
    return Number.isFinite(until) && until > now;
  } catch (e) {
    return false;
  }
}

export function applyWalletTestFromUrl(search = typeof window !== 'undefined' ? window.location.search : '', storage = local(), now = Date.now()) {
  try {
    const v = new URLSearchParams(search || '').get('walletTest');
    if (!storage || !v) return;
    if (v === 'on') storage.setItem(KEY, String(now + WALLET_TEST_DAYS * 24 * 3600 * 1000));
    else if (v === 'off') storage.removeItem(KEY);
  } catch (e) { /* no storage: the test stays off */ }
}
